/*
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { FirebaseRemoteConfig } from "@capacitor-firebase/remote-config";

import { AppDispatch } from "../../../store/rootStore";
import { debug, log } from "../../../util/log";

import RemoteConfigSlice, { remoteConfigInitialState } from "./remoteConfig.slice";
import { RemoteConfigState } from "./types";

export const syncRemoteConfigKey = async (
  key: string,
  dispatch: AppDispatch,
  config: RemoteConfigState
) => {
  const valueType = typeof remoteConfigInitialState[key];
  switch (valueType) {
    case "string":
      {
        const { value } = await FirebaseRemoteConfig.getString({
          key: key,
        });
        if (value !== config[key]) {
          debug("Getting key was: ", key, value);
          dispatch(RemoteConfigSlice.actions.updateKey({ key, value }));
        }
      }
      break;
    case "number":
      {
        const { value } = await FirebaseRemoteConfig.getNumber({
          key: key,
        });
        if (value !== config[key]) {
          debug("Getting key was: ", key, value);
          dispatch(RemoteConfigSlice.actions.updateKey({ key, value }));
        }
      }
      break;
    case "boolean":
      {
        const { value } = await FirebaseRemoteConfig.getBoolean({
          key: key,
        });
        if (value !== config[key]) {
          debug("Getting key was: ", key, value);
          dispatch(RemoteConfigSlice.actions.updateKey({ key, value }));
        }
      }
      break;
    case "object":
      {
        const { value } = await FirebaseRemoteConfig.getString({
          key: key,
        });
        try {
          const obj = JSON.parse(value);
          if (JSON.stringify(obj) !== JSON.stringify(config[key])) {
            debug("Getting key was: ", key, value);
            dispatch(RemoteConfigSlice.actions.updateKey({ key, value: obj }));
          }
        } catch {
          log("Failed to parse remote config key", key);
        }
      }
      break;
    default:
      log("Getting key was empty");
      log(valueType);
      break;
  }
};
